/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Price_PrInputs */

const en_fc_cmp_price_pr = /** @type {(inputs: Fc_Cmp_Price_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From US$22.99/mo (annual plan, first year)`)
};

/**
* | output |
* | --- |
* | "From US$22.99/mo (annual plan, first year)" |
*
* @param {Fc_Cmp_Price_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_price_pr = /** @type {((inputs?: Fc_Cmp_Price_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Price_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_price_pr(inputs)
});
export { fc_cmp_price_pr as "fc.cmp.price.pr" }